import React from "react";
import { useLocation } from "react-router-dom";
import Footer from "../Footer/Footer";
import Header from "../navbar/Navbar2";
import { Helmet } from "react-helmet";

const Layout = ({ children, title, description, keywords, author }) => {
  const location = useLocation();

  const canonicalUrl = `https://lawyeraderaw.com${location.pathname}`;

  const protectedHeader = () => {
    switch (location.pathname) {
      case "/sign-in":
      default:
        return <Header />;
    }
  };

  const protectedFooter = () => {
    switch (location.pathname) {
      case "/sign-in":
        return null;
      default:
        return <Footer />;
    }
  };

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <link rel="canonical" href={canonicalUrl} />
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:site_name" content="Aderaw Addisu Law Office" />
        <meta
          property="og:image"
          content="https://lawyeraderaw.com/LawLogo2-removebg-preview.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta
          name="twitter:image"
          content="https://lawyeraderaw.com/LawLogo2-removebg-preview.png"
        />

        <script type="application/ld+json">
          {`
{
 "@context": "https://schema.org",
 "@type": "LegalService",
 "name": "Aderaw Addisu Law Office",
 "url": "https://lawyeraderaw.com",
 "image": "https://lawyeraderaw.com/LawLogo2-removebg-preview.png",
 "description": "Professional legal and arbitration services in Bahir Dar, Ethiopia including litigation, contract law, property law, and legal consultation.",
 "areaServed": {
   "@type": "Country",
   "name": "Ethiopia"
 },
 "address": {
   "@type": "PostalAddress",
   "addressLocality": "Bahir Dar",
   "addressCountry": "Ethiopia"
 },
 "serviceType": [
   "Legal Consultation",
   "Litigation",
   "Arbitration Services",
   "Contract Drafting",
   "Property Law",
   "Business Law"
 ]
}
`}
        </script>
      </Helmet>

      {protectedHeader()}
      <main>{children}</main>
      {protectedFooter()}
    </div>
  );
};

Layout.defaultProps = {
  title: "Aderaw Addisu Law Office | Lawyer in Bahir Dar, Ethiopia",

  description:
    "Aderaw Addisu Law Office provides professional legal services in Bahir Dar, Ethiopia including arbitration, litigation, contract drafting, property law, business law, and legal consultation.",

  keywords:
    "Aderaw Addisu, Lawyer Aderaw, Lawyer in Bahir Dar, Law Firm in Bahir Dar, Legal Consultant Ethiopia, Arbitration Lawyer Ethiopia, Property Lawyer",

  author: "Aderaw Addisu Law Office",
};

export default Layout;
